<template>
  <div>
    <div class="batch-info" v-loading="loading">
      <div class="batch-info-title">药品信息</div>
      <div class="batch-info-item-box">
        <div class="batch-info-item">
          <div class="batch-info-item-label">药品通用名</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.commonName"
            class="batch-info-item-value"
          >
            {{ drugInfo.commonName }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">剂型</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.dosageForm"
            class="batch-info-item-value"
          >
            {{ drugInfo.dosageForm }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">制剂规格</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.drugSpecification"
            class="batch-info-item-value"
          >
            {{ drugInfo.drugSpecification }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">货主机构</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.ownEnterprise"
            class="batch-info-item-value"
          >
            {{ drugInfo.ownEnterprise }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">上市持有人</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.quotedHolder"
            class="batch-info-item-value"
          >
            {{ drugInfo.quotedHolder }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">批准文号</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.approvalNo"
            class="batch-info-item-value"
          >
            {{ drugInfo.approvalNo }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">文号有效期</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.approvalNoEndDate"
            class="batch-info-item-value"
          >
            {{ drugInfo.approvalNoEndDate }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">药品本位码</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.standardCode"
            class="batch-info-item-value"
          >
            {{ drugInfo.standardCode }}
          </EllipsisTooltip>
        </div>
        <div class="batch-info-item">
          <div class="batch-info-item-label">库存</div>
          ：
          <div class="batch-info-item-value">
            {{ drugInfo.quantity }}
          </div>
        </div>
      </div>
      <div class="batch-info-button-box">
        <span
          class="batch-info-button blue"
          style="margin-right: 11px"
          @click="handleQuantityClick"
          >全部追溯码</span
        >
        <span
          class="batch-info-button red"
          style="margin-right: 11px"
          @click="handleTableDetail({ standardCode: drugInfo.standardCode }, 1)"
          >全部入库</span
        >
        <span
          class="batch-info-button green"
          @click="handleTableDetail({ standardCode: drugInfo.standardCode }, 2)"
          >全部出库</span
        >
      </div>
    </div>

    <div class="batch-header">
      <div class="batch-header-left" v-loading="loading">
        <div class="batch-header-left-title">批次占比</div>
        <div class="batch-header-left-chart">
          <div class="header-left-chart">
            <div ref="batchPieRef" style="height: 180px" />
          </div>
          <div class="header-left-chart-text">
            <div class="chart-text-item" style="width: 40%">
              <div class="text-item-name">批次号</div>
              <div
                v-for="(v, i) in circleItems"
                :key="i"
                class="text-item-value"
              >
                <div
                  class="text-item-value-icon"
                  :style="`background:${color[i]}`"
                />
                <div class="text-item-value-title">{{ v.name }}</div>
              </div>
            </div>
            <div class="chart-text-item" style="width: 30%">
              <div class="text-item-name">存量</div>
              <div
                v-for="(v, i) in circleItems"
                :key="i"
                class="text-item-value"
              >
                {{ v.count }}
              </div>
            </div>
            <div class="chart-text-item" style="width: 30%">
              <div class="text-item-name">占比</div>
              <div
                v-for="(v, i) in circleItems"
                :key="i"
                class="text-item-value"
              >
                {{ v.percent }}%
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="batch-header-right">
        <div class="batch-header-right-item">
          <div class="header-right-item">
            <div class="header-right-item-label">药品追溯码</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.barcode"
                placeholder="请输入内容"
                style="font-size: 13px"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">包装规格</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.packageSpecification"
                multiple
                collapse-tags
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.packageSpecifications"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">生产批号</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.batchNo"
                placeholder="请输入内容"
                style="font-size: 13px"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
        </div>
        <div class="batch-header-right-item">
          <div class="header-right-item">
            <div class="header-right-item-label">国家药品标识码</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.nationalDrugCodes"
                multiple
                collapse-tags
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.nationalDrugCodes"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">生产企业</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.produceEnterprise"
                placeholder="请输入内容"
                style="font-size: 13px"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">库存情况</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.storageState"
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.stockStatus"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </div>
        <div class="batch-header-right-item">
          <div class="header-right-item">
            <div class="header-right-item-label">生产日期</div>
            <div class="header-right-item-value">
              <el-date-picker
                v-model="queryParam.produceDate"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                size="mini"
                placeholder="选择日期"
                :editable="false"
              />
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">有效期至</div>
            <div class="header-right-item-value">
              <el-date-picker
                v-model="queryParam.expireDate"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                size="mini"
                placeholder="选择日期"
                :editable="false"
              />
            </div>
          </div>
        </div>
        <div class="batch-header-right-button">
          <el-button type="primary" size="mini" @click="handleSearch"
            >查询</el-button
          >
          <el-button plain size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>

    <div class="batch-table">
      <div class="table-box">
        <div class="table-d">
          <el-table
            ref="workTableRef"
            :data="tableList"
            stripe
            :header-cell-style="{
              background: '#F0F3F7',
              color: '#2a354e',
              fontWeight: 400,
            }"
            height="260"
            highlight-current-row
            :row-key="'id'"
            @row-click="handleRowClick"
            @sort-change="handleSortChange"
            v-loading="loading"
            size="mini"
          >
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <span
                  style="color: #4076f2; cursor: pointer"
                  @click="handleTableDetail(scope.row, 0)"
                  >往来记录</span
                >
                <span
                  style="color: #6bc440; cursor: pointer; margin-left: 10px"
                  @click="handleTableCode(scope.row, 0)"
                  >追溯码详情</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="batchNo"
              label="生产批次"
              width="150"
              :show-overflow-tooltip="true"
              sortable="custom"
            />
            <el-table-column
              prop="packageSpecification"
              label="包装规格"
              width="150"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="quantity"
              label="库存"
              width="150"
              :show-overflow-tooltip="true"
              sortable="custom"
            />
            <el-table-column
              prop="inventoryDay"
              label="库存天数"
              width="150"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="produtionEnterpriseName"
              label="生产企业"
              width="250"
            />
            <el-table-column
              prop="produceDate"
              label="生产日期"
              width="150"
              :show-overflow-tooltip="true"
              sortable="custom"
            />
            <el-table-column
              prop="expireDate"
              label="有效期至"
              width="150"
              :show-overflow-tooltip="true"
              sortable="custom"
            />
            <el-table-column
              prop="nationalDrugCode"
              label="国家药品标识码"
              min-width="150"
              :show-overflow-tooltip="true"
            />
          </el-table>
        </div>
        <div class="table-page">
          <div class="table-page-index">当前 {{ paging.index }} 页</div>
          <el-pagination
            :current-page="paging.index"
            :page-size="paging.size"
            layout="total, prev, pager, next, jumper"
            :total="total"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <Code ref="codeRef" />
  </div>
</template>

<script>
import Code from "@/components/CodeList";
import EllipsisTooltip from "@/components/EllipsisTooltip";

export default {
  name: "Batch",
  components: { Code, EllipsisTooltip },
  props: {},
  data() {
    return {
      color: ["#1BC88E", "#4076F2", "#FF1616", "#D2D2D2"],
      queryParam: {
        standardCode: "",
        enterpriseName: "",
        barcode: "",
        packageSpecification: [],
        batchNo: "",
        nationalDrugCodes: [],
        produceEnterprise: "",
        storageState: "1",
        produceDate: "",
        expireDate: "",
        orders: {
          batchNo: null,
          quantity: null,
          inventoryDay: null,
          producedDate: null,
          expiredDate: null,
        },
      },
      paging: {
        index: 1,
        size: 100,
      },
      total: 0,
      circleItems: [],
      drugInfo: {},
      tableList: [],
      filterData: {},
      selectedRow: null,
      loading: false,
    };
  },
  methods: {
    handleSortChange(value) {
      // 生产批次
      if (value.prop === "batchNo") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.batchNo = true;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.batchNo = false;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
      }
      // 实时库存
      if (value.prop === "quantity") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.quantity = true;
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.quantity = false;
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
      }
      // 库存天数
      if (value.prop === "inventoryDay") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.inventoryDay = true;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.inventoryDay = false;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
      }
      // 生产日期
      if (value.prop === "produceDate") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.producedDate = true;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.producedDate = false;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.expiredDate = null;
        }
      }
      // 有效期至
      if (value.prop === "expireDate") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.batchNo = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.expiredDate = true;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.batchNo = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.expiredDate = false;
          this.queryParam.orders.producedDate = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.batchNo = null;
        }
      }
      this.paging.index = 1;
      this.getList();
    },
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleTableCode(value) {
      this.$refs.codeRef.show({
        standardCode: this.queryParam.standardCode,
        enterpriseName: this.queryParam.enterpriseName,
        batchNo: value.batchNo,
      });
    },
    handleSearch() {
      this.paging.index = 1;
      this.getList();
    },
    handleReset() {
      this.queryParam.barcode = "";
      this.queryParam.packageSpecification = [];
      this.queryParam.batchNo = "";
      this.queryParam.nationalDrugCodes = [];
      this.queryParam.produceEnterprise = "";
      this.queryParam.storageState = "1";
      this.queryParam.produceDate = "";
      this.queryParam.expireDate = "";
    },
    handleQuantityClick() {
      this.$refs.codeRef.show({
        standardCode: this.queryParam.standardCode,
        enterpriseName: this.queryParam.enterpriseName,
      });
    },
    handleSizeChange(value) {
      this.paging.index = 1;
      this.paging.size = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.paging.index = value;
      this.getList();
    },
    handleTableDetail(value, type) {
      const obj = {
        type: type,
        tableData: value,
        enterpriseName: this.queryParam.enterpriseName,
      };
      this.$emit("batchTableDetail", obj);
    },
    async getList() {
      this.loading = true;
      const { data, extended } = await this.$api.stock.GetStockBatchDetailList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.tableList = data;
      this.total = extended.paging.total;
      this.loading = false;
    },
    async pageFetchData(standardCode, enterpriseName) {
      this.loading = true;
      this.queryParam.standardCode = standardCode;
      this.queryParam.enterpriseName = enterpriseName;
      const { data } = await this.$api.stock.GetStockBatchDetail(
        this.queryParam
      );
      this.circleItems = data.circleItems;
      this.drugInfo = data.drug;
      const { data: batchData, extended } =
        await this.$api.stock.GetStockBatchDetailList({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = batchData;
      this.total = extended.paging.total;
      const { data: filterData } =
        await this.$api.stock.GetStockBatchDetailFilter(this.queryParam);
      this.filterData = filterData;
      this.loading = false;
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./batch.scss";
</style>
